import { useLanguage } from "@digipost/translate";

import { translator } from "./translator";

const DEFAULT_LANGUAGE = "nb";

export const useTranslate = () => {
  const { language: contextLanguage } = useLanguage();

  return translator.translateFn(contextLanguage || DEFAULT_LANGUAGE);
};
